import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

export const FullLoadingPage = () => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: '#f9f9f9',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
            }}
        >
            <CircularProgress size={64} thickness={4} color="primary" />
            <Typography variant="h6" sx={{ mt: 2, color: '#666' }}>
                Loading, please wait...
            </Typography>
        </Box>
    );
}
